import request from "../Tools/request/request";
// 发布公告
export function postdataNotice(data) {
    return request({
        url: "/community/postdata/notice",
        method: "post",
        data,
    });
}
// 公告分页查询
export function noticeList(data) {
    return request({
        url: "/community/notice/list",
        method: "post",
        data,
    });
}
// 公告-删除
export function deleteNotice(data) {
    return request({
        url: "/community/notice/del",
        method: "post",
        data,
    });
}